// src/components/ui/EmptyState.tsx
import SafeText from '../SafeText';

export default function EmptyState({ title, description }: { title: string | unknown; description?: string | unknown }) {
  return (
    <div className="text-center bg-[var(--surface-card)] border border-[var(--border-default)] rounded-xl p-8">
      <div className="text-lg font-semibold text-[var(--text-primary)]"><SafeText value={title} label="EmptyState.title" /></div>
      {description != null && (
        <div className="text-sm mt-1 text-[var(--text-secondary)]">
          <SafeText value={description} label="EmptyState.description" />
        </div>
      )}
    </div>
  );
}

